<!-- eslint-disable vue/valid-v-slot -->

<template>
  <div class="settlements-page">
    <!-- Page header -->
    <div class="page-header">
      <div class="page-header-text">
        <h1 class="page-title">{{ $t('settlements.title') }}</h1>
      </div>
    </div>

    <div v-if="generationReport" class="generation-report-summary">
      <div><strong>{{ $t('generationReport.lastReport') }}</strong><p>{{ reportSummary }}</p><small>{{ generationReport.request.startDate }} — {{ generationReport.request.endDate }} · {{ generationReport.finishedAt }}</small></div>
      <button class="action-pill action-pill--primary" @click="generationReportOpen = true"><v-icon size="16">mdi-clipboard-text-outline</v-icon>{{ $t('generationReport.openReport') }}</button>
      <p v-if="!generationReport.persistence.saved" class="generation-report-warning">{{ $t('generationReport.notSaved') }}</p>
      <p v-if="generationReport.status === 'FAILED'" class="generation-report-warning">{{ $t('generationReport.partialFailure') }}</p>
      <p v-if="generationRefreshFailed" class="generation-report-warning">{{ $t('generationReport.refreshFailed') }}</p>
      <p v-if="generationReport.persistence.saved" class="generation-report-history"><router-link to="/audit-logs">{{ $t('generationReport.history') }}</router-link> — {{ $t('generationReport.historyAccess') }}</p>
    </div>

    <!-- Filter Section -->
    <div class="filter-section mb-4">
      <div class="filter-section-header">
        <div class="filter-icon"><v-icon size="18" color="#5478FF">mdi-filter-variant</v-icon></div>
        <div class="filter-title">{{ $t('settlements.filters') }}</div>
      </div>
      <v-row>
        <v-col cols="12" md="3">
          <v-select
            v-model="filters.subCompany"
            :items="subCompanies"
            :label="$t('settlements.department')"
            outlined dense hide-details
            @change="initialize"
            multiple
            item-text="name"
            item-value="id"
            prepend-inner-icon="mdi-domain"
          ></v-select>
        </v-col>
        <v-col cols="12" md="6">
              <!-- <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filters.startDate"
                    label="Data rozp."
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    @change="initialize()"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filters.startDate"
                  first-day-of-week="1"
                  :locale="$i18n.locale"
                  @input="
                    startDateMenu = false;
                    initialize();
                  "
                ></v-date-picker>
              </v-menu> -->
          <v-text-field
            :label="$t('settlements.week')"
            v-model="filters.selectedDate"
            type="week"
            outlined dense hide-details
            prepend-inner-icon="mdi-calendar-week"
            @change="initialize(), initialize1(), initialize2()"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-select
            v-model="filters.settlementType"
            :items="settlementTypes"
            :label="$t('settlements.settlementType')"
            outlined dense hide-details
            prepend-inner-icon="mdi-cash-multiple"
            @change="initialize(), initialize1(), initialize2()"
          ></v-select>
        </v-col>
      </v-row>

      <!-- Table Visibility Controls — segmented toggles -->
      <div class="visibility-controls">
        <div class="visibility-label">{{ $t('settlements.tableVisibility') }}</div>
        <div class="visibility-pills">
          <button
            class="action-pill"
            :class="showPositiveTable ? 'action-pill--success' : 'action-pill--neutral'"
            @click="showPositiveTable = !showPositiveTable"
          >
            <v-icon size="14">{{ showPositiveTable ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
            {{ $t('settlements.title') }}
          </button>
          <button
            class="action-pill"
            :class="showNegativeTable ? 'action-pill--error' : 'action-pill--neutral'"
            @click="showNegativeTable = !showNegativeTable"
          >
            <v-icon size="14">{{ showNegativeTable ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
            {{ $t('settlements.negative') }}
          </button>
          <button
            class="action-pill"
            :class="showDeletedDriversTable ? 'action-pill--warning' : 'action-pill--neutral'"
            @click="showDeletedDriversTable = !showDeletedDriversTable"
          >
            <v-icon size="14">{{ showDeletedDriversTable ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
            {{ $t('settlements.deletedDrivers') }}
          </button>
        </div>
      </div>
    </div>

      <!-- Editable Data Table -->
      <v-data-table
        v-if="showPositiveTable"
        :headers="headers"
        :items="items"
        :loading="loading"
        :search="search"
        :options.sync="options"
        :server-items-length="totalItems"
        class="elevation-1"
        dense
        outlined
        editable
      >
      <template v-slot:item.driver="{ item }">
          <a href="#" @click.prevent="infoDriver(item.id)"
             style="text-decoration: underline; cursor: pointer; color: #1976d2;">
            {{ item.driver }}
          </a>
        </template>
      <template v-slot:item.settlementType="{ item }">{{ settlementTypeLabel(item.settlementType) }}</template>
      <template v-slot:item.cooperationType="{ item }">{{ cooperationTypeLabel(item.cooperationType) }}</template>
      <template v-slot:item.totalBolt="{ item }">{{ item.totalBolt }}</template>
      <template v-slot:item.totalUber="{ item }">{{ item.totalUber }}</template>
      <template v-slot:item.totalFn="{ item }">{{ item.totalFn }}</template>
      <template v-slot:item.totalVat="{ item }">
          {{ item.totalVat }} <span v-if="item.rawTotalInvoices != null" class="grey--text">({{ item.rawTotalInvoices }})</span>
        </template>
      <template v-slot:item.zusDeduction="{ item }">
        <span v-if="item.zusDeduction > 0" class="red--text">−{{ item.zusDeduction.toFixed(2) }}</span>
        <span v-else class="grey--text">—</span>
      </template>
      <template v-slot:item.details="{ item }">
            <v-btn class="warning" @click="infoDriver(item.id)"
              ><v-icon small class="pt-1">mdi-pencil</v-icon></v-btn
            >
          </template>
        <template v-slot:top>
          <div class="table-section-title">
            <div class="filter-icon"><v-icon size="18" color="#5478FF">mdi-cash-check</v-icon></div>
            <div class="filter-title">{{ $t('settlements.title') }}</div>
            <button class="action-pill" style="margin-right: 8px;" @click="cleanupZombie()" title="Usuń błędne rozliczenia 0/-80 zł (kierowcy bez zarobków)">
              <v-icon size="14">mdi-broom</v-icon>Wyczyść błędne (0/-80 zł)
            </button>
            <button class="action-pill action-pill--primary" :disabled="generating" @click="createSettlement()">
              <v-icon size="14">mdi-cash-plus</v-icon>{{ $t('settlements.settle') }}
            </button>
          </div>
          <div class="search-row">
            <div class="search-input">
              <v-icon size="18" color="#6E7691">mdi-magnify</v-icon>
              <input v-model="search" type="text" :placeholder="$t('common.search')" />
            </div>
          </div>
        </template>
      </v-data-table>
    <!-- Negative Settlements Data Table -->
    <v-data-table
        v-if="showNegativeTable"
        :headers="headers"
        :items="items1"
        :loading="loading"
        :search="search1"
        :options.sync="options1"
        :server-items-length="totalItems1"
        class="elevation-1"
        dense
        outlined
        editable
      >
      <template v-slot:item.driver="{ item }">
          <a href="#" @click.prevent="infoDriver(item.id)"
             style="text-decoration: underline; cursor: pointer; color: #1976d2;">
            {{ item.driver }}
          </a>
        </template>
      <template v-slot:item.settlementType="{ item }">{{ settlementTypeLabel(item.settlementType) }}</template>
      <template v-slot:item.cooperationType="{ item }">{{ cooperationTypeLabel(item.cooperationType) }}</template>
      <template v-slot:item.totalBolt="{ item }">{{ item.totalBolt }}</template>
      <template v-slot:item.totalUber="{ item }">{{ item.totalUber }}</template>
      <template v-slot:item.totalFn="{ item }">{{ item.totalFn }}</template>
      <template v-slot:item.zusDeduction="{ item }">
        <span v-if="item.zusDeduction > 0" class="red--text">−{{ item.zusDeduction.toFixed(2) }}</span>
        <span v-else class="grey--text">—</span>
      </template>
      <template v-slot:item.details="{ item }">
            <v-btn class="warning" @click="infoDriver(item.id)"
              ><v-icon small class="pt-1">mdi-pencil</v-icon></v-btn
            >
          </template>
        <template v-slot:top>
          <div class="table-section-title">
            <div class="filter-icon" style="background: rgba(244,67,54,0.18);"><v-icon size="18" color="#FF8A80">mdi-cash-remove</v-icon></div>
            <div class="filter-title">{{ $t('settlements.negative') }}</div>
          </div>
          <div class="search-row">
            <div class="search-input">
              <v-icon size="18" color="#6E7691">mdi-magnify</v-icon>
              <input v-model="search1" type="text" :placeholder="$t('common.search')" />
            </div>
          </div>
        </template>
      </v-data-table>

      <!-- Deleted Drivers Data Table -->
      <v-data-table
        v-if="showDeletedDriversTable"
        :headers="headers"
        :items="items2"
        :loading="loading"
        :search="search2"
        :options.sync="options2"
        :server-items-length="totalItems2"
        class="elevation-1"
        dense
        outlined
        editable
      >
        <template v-slot:item.driver="{ item }">
          <a href="#" @click.prevent="infoDriver(item.id)"
             style="text-decoration: underline; cursor: pointer; color: #1976d2;">
            {{ item.driver }}
          </a>
        </template>
        <template v-slot:item.settlementType="{ item }">{{ settlementTypeLabel(item.settlementType) }}</template>
      <template v-slot:item.cooperationType="{ item }">{{ cooperationTypeLabel(item.cooperationType) }}</template>
      <template v-slot:item.totalBolt="{ item }">{{ item.totalBolt }}</template>
        <template v-slot:item.totalUber="{ item }">{{ item.totalUber }}</template>
        <template v-slot:item.totalFn="{ item }">{{ item.totalFn }}</template>
        <template v-slot:item.zusDeduction="{ item }">
          <span v-if="item.zusDeduction > 0" class="red--text">−{{ item.zusDeduction.toFixed(2) }}</span>
          <span v-else class="grey--text">—</span>
        </template>
        <template v-slot:item.details="{ item }">
          <v-btn class="warning" @click="infoDriver(item.id)"
            ><v-icon small class="pt-1">mdi-pencil</v-icon></v-btn
          >
        </template>
        <template v-slot:top>
          <div class="table-section-title">
            <div class="filter-icon" style="background: rgba(255,152,0,0.18);"><v-icon size="18" color="#FFB74D">mdi-account-off</v-icon></div>
            <div class="filter-title">{{ $t('settlements.deletedDrivers') }}</div>
          </div>
          <div class="search-row">
            <div class="search-input">
              <v-icon size="18" color="#6E7691">mdi-magnify</v-icon>
              <input v-model="search2" type="text" :placeholder="$t('common.search')" />
            </div>
          </div>
        </template>
      </v-data-table>
    <settlement-generation-report-dialog v-model="generationReportOpen" :report="generationReport" :sub-companies="subCompanies" @wymus="wymusRozliczenie" />
  </div>
</template>

<script>
import * as dayjs from "dayjs";
import Swal from "sweetalert2";
import SettlementGenerationReportDialog from '@/components/SettlementGenerationReportDialog.vue';
import { parseGenerationReport, generationSummary, formatReportMoney } from '@/utils/settlementGenerationReport';
const axios = require("axios");
import isoWeek from 'dayjs/plugin/isoWeek'
dayjs.extend(isoWeek)

export default {
  components: { SettlementGenerationReportDialog },
  data() {
    return {
      loading: false,
      generating: false,
      generationReport: null,
      generationReportOpen: false,
      generationRefreshFailed: false,
      search: "",
      search1: "",
      search2: "",
      options1: {
        page: 1,
        itemsPerPage: 10,
      },
      totalItems1: 0,
      options2: {
        page: 1,
        itemsPerPage: 10,
      },
      totalItems2: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      totalItems: 0,
      // Filters
      filters: {
        subCompany: null,
        // ISO week + isoWeekYear; <input type="week"> używa ISO 8601.
        // Wcześniej był hack `(dayjs().week()-1)` który powodował że default
        // ustawiał się o tydzień wstecz względem aktualnego tygodnia.
        selectedDate: dayjs().isoWeekYear() + '-W' + String(dayjs().isoWeek()).padStart(2, '0'),
        startDate: dayjs().startOf("week"),
        endDate: dayjs().endOf("week"),
        // Domyślnie "Wszystkie" — kierowcy z różnymi schedulami (WEEKLY,
        // MONTH, EVERY_2_WEEKS) byli niewidoczni gdy filter był na sztywno
        // ustawiony na WEEKLY i admin szukał kogoś z innym scheduleem.
        settlementType: "",
      },
      startDateMenu: false,
      endDateMenu: false,

      // Data
      items: [],
      items1: [],
      items2: [],
      nextId: 3,

      // Options
      subCompanies: [],
      settlementTypes: [
        { text: "Wszystkie", value: "" },
        { text: "Dziennie", value: "DAILY" },
        { text: "Tygodniowo", value: "WEEKLY" },
        { text: "Co 2 tygodnie", value: "EVERY_2_WEEKS" },
        { text: "Miesięcznie", value: "MONTH" },
      ],

      // Table Visibility
      showPositiveTable: true,
      showNegativeTable: true,
      showDeletedDriversTable: true,

      // Table Headers
      headers: [
        { text: "driver", value: "driver" },
        { text: "", value: "details", sortable: false },
        { text: "Rodzaj rozliczenia", value: "settlementType" },
        { text: "Rodzaj współpracy", value: "cooperationType" },
        { text: "Bolt", value: "totalBolt", class: 'col-bolt-header', cellClass: 'col-bolt-cell' },
        { text: "FreeNow", value: "totalFn", class: 'col-fn-header', cellClass: 'col-fn-cell' },
        { text: "Uber", value: "totalUber", class: 'col-uber-header', cellClass: 'col-uber-cell' },
        { text: "Wynajem", value: "totalRent" },
        { text: "Bonus", value: "totalBonus" },
        { text: "Zwrot z Faktur", value: "totalVat" },
        { text: "8% netto (max VAT)", value: "maxCostReimbursement" },
        { text: "Gotówka", value: "totalCash" },
        { text: "Koszt Rozliczenia", value: "settlementCost" },
        { text: "Koszt Administracyjny", value: "administrationTax" },
        { text: "Składki ZUS", value: "zusDeduction" },
        { text: "Poprzedni Tydzień", value: "totalPrevious" },
        { text: "Ten Tydzień", value: "totalWeek" },
        { text: "Do wypłaty", value: "total" },
      ],
    };
  },
  computed: {
    reportSummary() { return this.generationReport ? generationSummary(this.generationReport, this.$t.bind(this)) : ''; },
  },
  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    search: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    options1: {
      handler() {
        this.initialize1();
      },
      deep: true,
    },
    search1: {
      handler() {
        this.initialize1();
      },
      deep: true,
    },
    options2: {
      handler() {
        this.initialize2();
      },
      deep: true,
    },
    search2: {
      handler() {
        this.initialize2();
      },
      deep: true,
    },
  },
  async created() {
    this.setDefaultDates();
    await this.getSubcompanySelect();
    await this.initialize();
    await this.initialize1();
    await this.initialize2();
  },
  methods: {
    settlementTypeLabel(t) {
      return ({
        DAILY: 'Dziennie',
        WEEKLY: 'Tygodniowo',
        EVERY_2_WEEKS: 'Co 2 tygodnie',
        MONTH: 'Miesięcznie',
        MONTHLY: 'Miesięcznie',
      })[t] || t || '—';
    },
    cooperationTypeLabel(t) {
      return ({
        B2B_VAT: 'B2B VAT',
        B2B_NO_VAT: 'B2B bez VAT',
        FIFTY_FIFTY: 'Zlecenie 50/50',
        RENT: 'Najem',
        CONNECTION: 'Podpięcie',
        STUDENT: 'Student',
      })[t] || t || '—';
    },
    mapSortField(field) {
      const map = {
        totalFn: 'totalFreeNow',
        totalVat: 'combinedTotalInvoices',
        totalBonus: 'totalBonuses',
        maxCostReimbursement: 'combinedMaxCostReimbursement',
      };
      return map[field] || field;
    },
    async cleanupZombie() {
      const confirm = await Swal.fire({
        title: 'Wyczyścić błędne rozliczenia?',
        html: 'Usunie rozliczenia <b>0 zł / -80 zł</b> kierowców, którzy nie mają żadnych zarobków, bonusów ani faktur (figurują w CSV ale wzór dał 0).<br><br>Operacja odwracalna (soft-delete), ICD wrócą do PENDING.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Tak, wyczyść',
        cancelButtonText: 'Anuluj',
      });
      if (!confirm.isConfirmed) return;
      await this.toggleLoading(true);
      try {
        const res = await axios({
          method: 'post',
          url: process.env.VUE_APP_ROOT_API + 'settlements/cleanup-zombie',
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        });
        const d = res.data.data;
        await this.toggleLoading(false);
        await Swal.fire(
          'Gotowe',
          `Usunięto ${d.removed} błędnych rozliczeń. Odpięto ${d.icdDetached} wierszy importu (wróciły do PENDING).`,
          'success',
        );
        location.reload();
      } catch (e) {
        await this.toggleLoading(false);
        Swal.fire('Błąd', e.response?.data?.message?.toString() || 'Nie udało się wyczyścić', 'error');
      }
    },
    async createSettlement() {
      if (this.generating) return;
      // Serwer wymaga typu rozliczenia — bez niego odrzucał żądanie, a panel
      // pokazywał tylko ogólny błąd (12.10.2026, 4 próby rozliczenia Tkaczyka).
      if (!this.filters.settlementType) {
        Swal.fire({ icon: 'info', title: 'Wybierz typ rozliczenia', text: 'Przed generowaniem wybierz w filtrze typ (np. tygodniowe, co 2 tygodnie).' });
        return;
      }
      this.generating = true;
      try {
          await Swal.fire("Uwaga", "Rozpoczęto Generowanie Wypłat!", "warning");
          await this.toggleLoading(true);
          this.generationReport = null;
          this.generationRefreshFailed = false;
          try {
            // weekYearStr format: "WW-YYYY" (e.g. "22-2025")
            const [yearStr, weekStr] = this.filters.selectedDate.split('-')
  const week = parseInt(weekStr.replace('W',''))
  const year = parseInt(yearStr)
  // Step 1: Find the first day of the year
  const jan4 = dayjs(`${year}-01-04`) // Jan 4 is always in week 1 ISO
  const dayOfWeek = jan4.day() // Sunday=0 ... Saturday=6
  // Calculate offset from Monday (1)
  const diff = (dayOfWeek === 0 ? -6 : 1) - dayOfWeek
  const firstMonday = jan4.add(diff, 'day')

  // Step 2: Add (week-1) * 7 days
  const start = firstMonday.add((week - 1) * 7, 'day')
  const end = start.add(6, 'day')
            const createRes = await axios({
              method: "post",
              url: process.env.VUE_APP_ROOT_API + "settlements/create",
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
              data: {
                startDate: dayjs(start).format('YYYY-MM-DD'),
                endDate:  dayjs(end).format('YYYY-MM-DD'),
                subCompanyIds: this.filters.subCompany || [],
                settlementType: this.filters.settlementType,
                search: this.search || "",
              },
            });
            const data = createRes.data?.data || {};
            this.generationReport = parseGenerationReport(data.generationReport);
            await this.refreshGenerationList();
            if (this.generationReport) this.generationReportOpen = true;
            else this.showLegacyGenerationResult(data);
          } catch (e) {
            const body = e.response?.data;
            this.generationReport = parseGenerationReport(body?.generationReport || body?.data?.generationReport);
            if (this.generationReport) {
              await this.refreshGenerationList();
              this.generationReportOpen = true;
            } else {
              Swal.fire({ icon: 'error', title: this.$t('generationReport.errorTitle'), text: this.$t('generationReport.requestFailed') });
            }
          }
      } finally {
          await this.toggleLoading(false);
          this.generating = false;
      }
    },
    // Head admin: rozlicz jednego kierowcę pominiętego tylko za brak zarobków
    // z aplikacji. Rozliczenie normalne — zleceniówka i ZUS jak zawsze.
    async wymusRozliczenie(row) {
      if (this.generating || !this.generationReport) return;
      const req = this.generationReport.request;
      const ok = await Swal.fire({
        icon: 'warning',
        title: 'Rozliczyć mimo braku zarobków z aplikacji?',
        html: `${row.name}: zarobki z aplikacji ${formatReportMoney(row.actualCents)}, wymagane ${formatReportMoney(row.requiredCents)}.<br>Rozliczenie powstanie normalnie — ze zleceniówką i ZUS — za okres ${req.startDate} – ${req.endDate}.`,
        showCancelButton: true,
        confirmButtonText: 'Rozlicz',
        cancelButtonText: 'Anuluj',
      });
      if (!ok.isConfirmed) return;
      this.generating = true;
      await this.toggleLoading(true);
      try {
        const res = await axios({
          method: 'post',
          url: process.env.VUE_APP_ROOT_API + 'settlements/create',
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
          data: {
            startDate: req.startDate,
            endDate: req.endDate,
            subCompanyIds: [],
            ...(req.settlementType ? { settlementType: req.settlementType } : {}),
            search: '',
            onlyDriverId: row.driverId,
            wymusMimoBrakuZarobkow: true,
          },
        });
        this.generationReport = parseGenerationReport(res.data?.data?.generationReport) || this.generationReport;
        await this.refreshGenerationList();
        this.generationReportOpen = true;
      } catch (e) {
        Swal.fire({ icon: 'error', title: this.$t('generationReport.errorTitle'), text: e.response?.data?.message || this.$t('generationReport.requestFailed') });
      } finally {
        await this.toggleLoading(false);
        this.generating = false;
      }
    },
    showLegacyGenerationResult(data) {
      const skipped = Array.isArray(data.skippedNoOdometer) ? data.skippedNoOdometer : [];
      const inspections = Array.isArray(data.skippedInspectionSummon) ? data.skippedInspectionSummon : [];
      const fees = Array.isArray(data.feeCharged) ? data.feeCharged : [];
      const lines = [this.$t('generationReport.legacyHint')];
      if (skipped.length) lines.push(this.$t('generationReport.legacyOdometer'), ...skipped.map(row => `${row.name || '—'} (${row.plate || '—'})`));
      if (inspections.length) lines.push(this.$t('generationReport.legacyInspection'), ...inspections.map(row => row.name || '—'));
      if (fees.length) lines.push(this.$t('generationReport.legacyFees'), ...fees.map(row => `${row.name || '—'} — ${formatReportMoney(row.amount, this.$i18n.locale)}`));
      // Nazwy kierowców zawsze jako tekst — nigdy interpolowane do HTML.
      Swal.fire({ icon: 'warning', title: this.$t('generationReport.legacyTitle'), text: lines.join('\n') });
    },
    async refreshGenerationList() {
      try { await this.initialize(); } catch (e) {
        // Błąd odświeżania nie zmienia otrzymanego wyniku operacji POST.
        this.loading = false;
        this.generationRefreshFailed = true;
      }
    },
    async toggleLoading(type) {
      const toggle = type;
      localStorage.setItem("loading", toggle);
      window.dispatchEvent(
        new CustomEvent("toggleLoading", {
          detail: {
            loading: localStorage.getItem("loading"),
            overlay: localStorage.getItem("loading"),
          },
        })
      );
    },
    async infoDriver(id){
      location.href = `/driver-details?id=${id}`;
    },
    async getSubcompanySelect() {
      await this.toggleLoading(true);
      try {
        const subCompanies = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + `sub-company`,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.subCompanies = subCompanies.data.data.map((it) => {
          return {
            id: it.id,
            name: it.name,
          };
        });
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      await this.toggleLoading(false);
    },
    setDefaultDates() {
      // Get current date
      const currentDate = dayjs();

      // Get start of the week (Sunday or Monday depending on locale)
      const startOfWeek = currentDate.startOf("week"); // Defaults to Sunday
      this.filters.startDate = startOfWeek.format("YYYY-MM-DD");

      // Get end of the week (Saturday or Sunday depending on locale)
      const endOfWeek = currentDate.endOf("week"); // Defaults to Saturday
      this.filters.endDate = endOfWeek.format("YYYY-MM-DD");
    },
    async initialize() {
      this.loading = true;
      if (this.search.trim().length > 0) {
        this.options.page = 1;
      }
  // weekYearStr format: "WW-YYYY" (e.g. "22-2025")
  const [yearStr, weekStr] = this.filters.selectedDate.split('-')
  const week = parseInt(weekStr.replace('W',''))
  const year = parseInt(yearStr)

  // Step 1: Find the first day of the year
  const jan4 = dayjs(`${year}-01-04`) // Jan 4 is always in week 1 ISO
  const dayOfWeek = jan4.day() // Sunday=0 ... Saturday=6
  // Calculate offset from Monday (1)
  const diff = (dayOfWeek === 0 ? -6 : 1) - dayOfWeek
  const firstMonday = jan4.add(diff, 'day')

  // Step 2: Add (week-1) * 7 days
  const start = firstMonday.add((week - 1) * 7, 'day')
  const end = start.add(6, 'day')
      try {
        const response = await axios.get(
          process.env.VUE_APP_ROOT_API +
            `settlements/positive?take=${this.options.itemsPerPage}&skip=${this.options.page}&search=${this.search}`,
          {
            params: {
              subCompanyIds: this.filters.subCompany,
              startDate: dayjs(start).format('YYYY-MM-DD'),
              endDate:  dayjs(end).format('YYYY-MM-DD'),
              settlementType: this.filters.settlementType,
              sortBy: this.options.sortBy?.[0] ? this.mapSortField(this.options.sortBy[0]) : undefined,
              sortOrder: this.options.sortDesc?.[0] ? 'desc' : this.options.sortBy?.[0] ? 'asc' : undefined,
            },
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
        this.items = response.data.data.result.map((it) => {
          return {
            id: it.id,
            driver: it.firstName + " " + it.lastName,
            settlementType: it.payoutSchedule,
            cooperationType: it.cooperationType,
            zusDeduction: (it.zusDeduction || 0) / 100,
            totalBolt: it.totalBolt / 100,
            totalFn: it.totalFreeNow / 100,
            totalUber: it.totalUber / 100,
            totalRent: it.totalRent / 100,
            totalBonus: (it.totalBonuses || 0) / 100,
            totalVat: (it.combinedTotalInvoices != null ? it.combinedTotalInvoices : it.totalInvoices) / 100,
            rawTotalInvoices: it.combinedRawTotalInvoices != null ? it.combinedRawTotalInvoices / 100 : null,
            maxCostReimbursement: (it.combinedMaxCostReimbursement != null ? it.combinedMaxCostReimbursement : it.maxCostReimbursement || 0) / 100,
            totalCash: it.totalCash / 100,
            totalPrevious: it.totalPrevious / 100,
            settlementCost: it.settlementCost / 100,
            administrationTax: it.administrationTax / 100,
            totalWeek: it.totalWeek / 100,
            total: it.total / 100,
          };
        });
        this.totalItems = response.data.data.count;
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      this.loading = false;
    },
    async initialize1() {
      this.loading = true;
      if (this.search1.trim().length > 0) {
        this.options1.page = 1;
      }
    // weekYearStr format: "WW-YYYY" (e.g. "22-2025")
  const [yearStr, weekStr] = this.filters.selectedDate.split('-')
  const week = parseInt(weekStr.replace('W',''))
  const year = parseInt(yearStr)

  // Step 1: Find the first day of the year
  const jan4 = dayjs(`${year}-01-04`) // Jan 4 is always in week 1 ISO
  const dayOfWeek = jan4.day() // Sunday=0 ... Saturday=6
  // Calculate offset from Monday (1)
  const diff = (dayOfWeek === 0 ? -6 : 1) - dayOfWeek
  const firstMonday = jan4.add(diff, 'day')

  // Step 2: Add (week-1) * 7 days
  const start = firstMonday.add((week - 1) * 7, 'day')
  const end = start.add(6, 'day')
      try {
        const response = await axios.get(
          process.env.VUE_APP_ROOT_API +
            `settlements/negative?take=${this.options1.itemsPerPage}&skip=${this.options1.page}&search=${this.search1}`,
          {
            params: {
              subCompanyIds: this.filters.subCompany,
              startDate: dayjs(start).format('YYYY-MM-DD'),
              endDate:  dayjs(end).format('YYYY-MM-DD'),
              settlementType: this.filters.settlementType,
              sortBy: this.options1.sortBy?.[0] ? this.mapSortField(this.options1.sortBy[0]) : undefined,
              sortOrder: this.options1.sortDesc?.[0] ? 'desc' : this.options1.sortBy?.[0] ? 'asc' : undefined,
            },
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
        this.items1 = response.data.data.result.map((it) => {
          return {
            id: it.id,
            driver: it.firstName + " " + it.lastName,
            settlementType: it.payoutSchedule,
            cooperationType: it.cooperationType,
            zusDeduction: (it.zusDeduction || 0) / 100,
            totalBolt: it.totalBolt / 100,
            totalFn: it.totalFreeNow / 100,
            totalUber: it.totalUber / 100,
            totalRent: it.totalRent / 100,
            totalBonus: (it.totalBonuses || 0) / 100,
            totalVat: (it.combinedTotalInvoices != null ? it.combinedTotalInvoices : it.totalInvoices) / 100,
            rawTotalInvoices: it.combinedRawTotalInvoices != null ? it.combinedRawTotalInvoices / 100 : null,
            maxCostReimbursement: (it.combinedMaxCostReimbursement != null ? it.combinedMaxCostReimbursement : it.maxCostReimbursement || 0) / 100,
            totalCash: it.totalCash / 100,
            totalPrevious: it.totalPrevious / 100,
            settlementCost: it.settlementCost / 100,
            administrationTax: it.administrationTax / 100,
            totalWeek: it.totalWeek / 100,
            total: it.total / 100,
          };
        });
        this.totalItems1 = response.data.data.count;
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      this.loading = false;
    },
    async initialize2() {
      this.loading = true;
      if (this.search2.trim().length > 0) {
        this.options2.page = 1;
      }
    // weekYearStr format: "WW-YYYY" (e.g. "22-2025")
  const [yearStr, weekStr] = this.filters.selectedDate.split('-')
  const week = parseInt(weekStr.replace('W',''))
  const year = parseInt(yearStr)

  // Step 1: Find the first day of the year
  const jan4 = dayjs(`${year}-01-04`) // Jan 4 is always in week 1 ISO
  const dayOfWeek = jan4.day() // Sunday=0 ... Saturday=6
  // Calculate offset from Monday (1)
  const diff = (dayOfWeek === 0 ? -6 : 1) - dayOfWeek
  const firstMonday = jan4.add(diff, 'day')

  // Step 2: Add (week-1) * 7 days
  const start = firstMonday.add((week - 1) * 7, 'day')
  const end = start.add(6, 'day')
      try {
        const response = await axios.get(
          process.env.VUE_APP_ROOT_API +
            `settlements/deleted-drivers?take=${this.options2.itemsPerPage}&skip=${this.options2.page}&search=${this.search2}`,
          {
            params: {
              subCompanyIds: this.filters.subCompany,
              startDate: dayjs(start).format('YYYY-MM-DD'),
              endDate:  dayjs(end).format('YYYY-MM-DD'),
              settlementType: this.filters.settlementType,
              sortBy: this.options2.sortBy?.[0] ? this.mapSortField(this.options2.sortBy[0]) : undefined,
              sortOrder: this.options2.sortDesc?.[0] ? 'desc' : this.options2.sortBy?.[0] ? 'asc' : undefined,
            },
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
        this.items2 = response.data.data.result.map((it) => {
          return {
            id: it.id,
            driver: it.firstName + " " + it.lastName,
            settlementType: it.payoutSchedule,
            cooperationType: it.cooperationType,
            zusDeduction: (it.zusDeduction || 0) / 100,
            totalBolt: it.totalBolt / 100,
            totalFn: it.totalFreeNow / 100,
            totalUber: it.totalUber / 100,
            totalRent: it.totalRent / 100,
            totalBonus: (it.totalBonuses || 0) / 100,
            totalVat: (it.combinedTotalInvoices != null ? it.combinedTotalInvoices : it.totalInvoices) / 100,
            rawTotalInvoices: it.combinedRawTotalInvoices != null ? it.combinedRawTotalInvoices / 100 : null,
            maxCostReimbursement: (it.combinedMaxCostReimbursement != null ? it.combinedMaxCostReimbursement : it.maxCostReimbursement || 0) / 100,
            totalCash: it.totalCash / 100,
            totalPrevious: it.totalPrevious / 100,
            settlementCost: it.settlementCost / 100,
            administrationTax: it.administrationTax / 100,
            totalWeek: it.totalWeek / 100,
            total: it.total / 100,
          };
        });
        this.totalItems2 = response.data.data.count;
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.generation-report-summary { display: flex; align-items: center; flex-wrap: wrap; gap: 12px; padding: 16px; border: 1px solid #526484; border-radius: 10px; margin-bottom: 18px; color: #e6ecf8; background: #202a3d; }
.generation-report-summary > div { flex: 1; min-width: 200px; }.generation-report-summary p { margin: 5px 0; }
.generation-report-summary small { color: #bcc8df; overflow-wrap: anywhere; }
.generation-report-summary .generation-report-warning { flex-basis: 100%; color: #ffe0a1; font-size: 13px; }
.generation-report-summary .generation-report-history { flex-basis: 100%; color: #c2cde0; font-size: 12px; }
.generation-report-history a { color: #a8c4ff; }.action-pill:disabled { opacity: .6; cursor: wait; }
/* === Driver-app aesthetic for admin Settlements === */
.settlements-page {
  background: #181C28;
  min-height: calc(100vh - 56px);
  padding: 16px 16px 40px;
  margin: -24px;
  color: #fff;
}
.settlements-page * { box-sizing: border-box; }

/* Page header */
.page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  padding: 4px 4px 18px;
}
.page-eyebrow {
  font-size: 12px;
  color: #6E7691;
  font-weight: 500;
  text-transform: capitalize;
}
.page-title {
  font-size: 22px;
  font-weight: 800;
  color: #fff;
  margin: 2px 0 0;
  letter-spacing: -0.02em;
}

/* Filter section */
.filter-section {
  background: #232838;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 18px;
  padding: 16px 18px;
}
.filter-section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}
.filter-icon {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: rgba(41, 98, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.filter-title {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.01em;
  flex-grow: 1;
}
.table-section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

/* Visibility controls */
.visibility-controls {
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}
.visibility-label {
  font-size: 11px;
  color: #6E7691;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 10px;
}
.visibility-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* Action pills */
.action-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #181C28;
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #fff;
  padding: 8px 14px;
  border-radius: 10px;
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: -0.01em;
  cursor: pointer;
  transition: transform 0.12s ease, background 0.15s ease, border-color 0.15s ease;
  font-family: inherit;
}
.action-pill:hover { transform: translateY(-1px); border-color: rgba(255,255,255,0.18); }
.action-pill:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
.action-pill .v-icon { color: inherit !important; }
.action-pill--primary { background: #2962FF; border-color: #2962FF; box-shadow: 0 4px 12px rgba(41,98,255,0.3); }
.action-pill--info    { background: rgba(66, 165, 245, 0.18); border-color: rgba(66,165,245,0.35); color: #64B5F6; }
.action-pill--success { background: rgba(45, 203, 115, 0.18); border-color: rgba(45,203,115,0.35); color: #6FE89A; }
.action-pill--warning { background: rgba(255, 152, 0, 0.18); border-color: rgba(255,152,0,0.35); color: #FFB74D; }
.action-pill--error   { background: rgba(244, 67, 54, 0.18); border-color: rgba(244,67,54,0.35); color: #FF8A80; }
.action-pill--neutral { background: rgba(255, 255, 255, 0.06); border-color: rgba(255,255,255,0.12); color: #B0BEC5; }

/* Search input */
.search-row { padding: 10px 14px 14px; }
.search-input {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #181C28;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 10px 14px;
}
.search-input input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 14px;
  font-family: inherit;
}
.search-input input::placeholder { color: #6E7691; }

/* === Vuetify deep overrides === */
.settlements-page >>> .v-card {
  background: #232838 !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
  border-radius: 18px !important;
  box-shadow: none !important;
  color: #fff !important;
}

/* Inputs */
.settlements-page >>> .v-text-field--outlined fieldset,
.settlements-page >>> .v-select--outlined fieldset {
  border-color: rgba(255,255,255,0.1) !important;
}
.settlements-page >>> .v-text-field--outlined .v-input__slot,
.settlements-page >>> .v-select--outlined .v-input__slot {
  background: #181C28 !important;
  border-radius: 12px !important;
  min-height: 44px !important;
}
.settlements-page >>> .v-label { color: #6E7691 !important; font-size: 13px !important; }
.settlements-page >>> .v-text-field input,
.settlements-page >>> .v-select__selection { color: #fff !important; }
.settlements-page >>> .v-input__prepend-inner .v-icon { color: #6E7691 !important; }

/* Data table — bg, header, body, footer */
.settlements-page >>> .v-data-table {
  background: #232838 !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
  border-radius: 18px !important;
  color: #fff !important;
  box-shadow: none !important;
  margin-bottom: 16px;
}
.settlements-page >>> .v-data-table thead tr th {
  background: #1F2434 !important;
  color: #6E7691 !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid rgba(255,255,255,0.06) !important;
}
/* Wyjątek: kolumny platformowe (Bolt/Uber/FN) zachowują własne gradienty z global style */
.settlements-page >>> .v-data-table thead tr th.col-bolt-header,
.settlements-page >>> .v-data-table thead tr th.col-uber-header,
.settlements-page >>> .v-data-table thead tr th.col-fn-header {
  color: #FFFFFF !important;
}
.settlements-page >>> .v-data-table tbody tr { background: #232838 !important; }
.settlements-page >>> .v-data-table tbody tr:hover { background: #2A3042 !important; }
.settlements-page >>> .v-data-table tbody tr td {
  color: #fff !important;
  border-bottom: 1px solid rgba(255,255,255,0.04) !important;
}
.settlements-page >>> .v-data-footer {
  background: #1F2434 !important;
  color: #B0BEC5 !important;
  border-top: 1px solid rgba(255,255,255,0.06) !important;
}

/* Driver link */
.settlements-page >>> .v-data-table a { color: #5478FF !important; }

/* Edit pencil button (warning) inside rows */
.settlements-page >>> .v-data-table tbody td .v-btn.warning {
  background: rgba(255, 152, 0, 0.18) !important;
  color: #FFB74D !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  box-shadow: none !important;
  min-width: 36px !important;
}
.settlements-page >>> .v-data-table tbody td .v-btn .v-icon { color: inherit !important; }

/* Chips */
.settlements-page >>> .v-chip {
  border-radius: 999px !important;
  font-weight: 700 !important;
}

/* Loading bar / dividers */
.settlements-page >>> .v-progress-linear { background: rgba(255,255,255,0.06) !important; }
.settlements-page >>> .v-divider { border-color: rgba(255,255,255,0.06) !important; }

/* Toolbar (in case any v-toolbar still rendered somewhere) */
.settlements-page >>> .v-toolbar { background: transparent !important; color: #fff !important; }
</style>

<!-- Globalne — pełne wypełnienie kolumn z gładkimi przejściami -->
<style>
/* ===== Wspólne style wszystkich 3 kolumn ===== */
.v-data-table th.col-bolt-header,
.v-data-table th.col-uber-header,
.v-data-table th.col-fn-header,
.v-data-table td.col-bolt-cell,
.v-data-table td.col-uber-cell,
.v-data-table td.col-fn-cell {
  color: #FFFFFF !important;
  font-weight: 700 !important;
  font-variant-numeric: tabular-nums;
  border: none !important;
  transition: background-color 0.2s ease;
}

/* Nagłówki */
.v-data-table th.col-bolt-header,
.v-data-table th.col-uber-header,
.v-data-table th.col-fn-header {
  font-size: 12px !important;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  text-align: center !important;
  padding: 14px 12px !important;
  position: relative;
}
/* Delikatny cień pod nagłówkiem — łagodne przejście do komórek */
.v-data-table th.col-bolt-header::after,
.v-data-table th.col-uber-header::after,
.v-data-table th.col-fn-header::after {
  content: '';
  position: absolute;
  left: 0; right: 0; bottom: 0;
  height: 4px;
  background: linear-gradient(180deg, rgba(0,0,0,0.2), transparent);
}

/* Komórki */
.v-data-table td.col-bolt-cell,
.v-data-table td.col-uber-cell,
.v-data-table td.col-fn-cell {
  text-align: right !important;
  padding: 10px 14px !important;
  font-size: 13px !important;
}

/* ===== BOLT — zielony z gradientem (ciemniejszy dla lepszego kontrastu) ===== */
.v-data-table th.col-bolt-header {
  background: linear-gradient(180deg, #388E3C 0%, #2E7D32 100%) !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
}
.v-data-table td.col-bolt-cell {
  background: linear-gradient(90deg, #2E7D32 0%, #256628 100%) !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
}
.v-data-table tbody tr:hover td.col-bolt-cell {
  background: linear-gradient(90deg, #388E3C 0%, #2E7D32 100%) !important;
}

/* ===== UBER — czarny z gradientem ===== */
.v-data-table th.col-uber-header {
  background: linear-gradient(180deg, #424242 0%, #212121 100%) !important;
}
.v-data-table td.col-uber-cell {
  background: linear-gradient(90deg, #212121 0%, #1A1A1A 100%) !important;
}
.v-data-table tbody tr:hover td.col-uber-cell {
  background: linear-gradient(90deg, #424242 0%, #303030 100%) !important;
}

/* ===== FREENOW — czerwony z gradientem ===== */
.v-data-table th.col-fn-header {
  background: linear-gradient(180deg, #EF5350 0%, #F44336 100%) !important;
}
.v-data-table td.col-fn-cell {
  background: linear-gradient(90deg, #F44336 0%, #E53935 100%) !important;
}
.v-data-table tbody tr:hover td.col-fn-cell {
  background: linear-gradient(90deg, #EF5350 0%, #F44336 100%) !important;
}

/* Zaokrąglone rogi — pierwsza kolumna app-specific (top-left) i ostatnia (top-right) */
.v-data-table th.col-bolt-header { border-top-left-radius: 8px; }
.v-data-table th.col-uber-header { border-top-right-radius: 8px; }

/* Ostatni wiersz: zaokrąglone dolne rogi */
.v-data-table tbody tr:last-child td.col-bolt-cell { border-bottom-left-radius: 8px; }
.v-data-table tbody tr:last-child td.col-uber-cell { border-bottom-right-radius: 8px; }
</style>
